import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULT_METRICS } from "@/lib/grades";

const MetricsContext = createContext(DEFAULT_METRICS);

export function MetricsProvider({ children }) {
  const [metrics, setMetrics] = useState(DEFAULT_METRICS);

  useEffect(() => {
    api
      .get("/metrics")
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length) setMetrics(r.data);
      })
      .catch(() => {});
  }, []);

  return <MetricsContext.Provider value={metrics}>{children}</MetricsContext.Provider>;
}

export const useMetrics = () => useContext(MetricsContext);
